// src/features/statistics/lib/country-names.ts
// ISO 3166-1 alpha-2 → русское название страны

const COUNTRY_NAMES: Record<string, string> = {
  AE: 'ОАЭ',
  AF: 'Афганистан',
  AL: 'Албания',
  AM: 'Армения',
  AO: 'Ангола',
  AR: 'Аргентина',
  AT: 'Австрия',
  AU: 'Австралия',
  AZ: 'Азербайджан',
  BA: 'Босния и Герцеговина',
  BD: 'Бангладеш',
  BE: 'Бельгия',
  BF: 'Буркина-Фасо',
  BG: 'Болгария',
  BH: 'Бахрейн',
  BJ: 'Бенин',
  BN: 'Бруней',
  BO: 'Боливия',
  BR: 'Бразилия',
  BW: 'Ботсвана',
  BY: 'Беларусь',
  BZ: 'Белиз',
  CA: 'Канада',
  CD: 'ДР Конго',
  CF: 'ЦАР',
  CG: 'Республика Конго',
  CH: 'Швейцария',
  CI: "Кот-д'Ивуар",
  CL: 'Чили',
  CM: 'Камерун',
  CN: 'Китай',
  CO: 'Колумбия',
  CR: 'Коста-Рика',
  CU: 'Куба',
  CV: 'Кабо-Верде',
  CY: 'Кипр',
  CZ: 'Чехия',
  DE: 'Германия',
  DJ: 'Джибути',
  DK: 'Дания',
  DO: 'Доминиканская Республика',
  DZ: 'Алжир',
  EC: 'Эквадор',
  EE: 'Эстония',
  EG: 'Египет',
  ER: 'Эритрея',
  ES: 'Испания',
  ET: 'Эфиопия',
  FI: 'Финляндия',
  FJ: 'Фиджи',
  FR: 'Франция',
  GA: 'Габон',
  GB: 'Великобритания',
  GE: 'Грузия',
  GH: 'Гана',
  GM: 'Гамбия',
  GN: 'Гвинея',
  GQ: 'Экваториальная Гвинея',
  GR: 'Греция',
  GT: 'Гватемала',
  GW: 'Гвинея-Бисау',
  GY: 'Гайана',
  HN: 'Гондурас',
  HR: 'Хорватия',
  HT: 'Гаити',
  HU: 'Венгрия',
  ID: 'Индонезия',
  IE: 'Ирландия',
  IL: 'Израиль',
  IN: 'Индия',
  IQ: 'Ирак',
  IR: 'Иран',
  IS: 'Исландия',
  IT: 'Италия',
  JM: 'Ямайка',
  JO: 'Иордания',
  JP: 'Япония',
  KE: 'Кения',
  KG: 'Кыргызстан',
  KH: 'Камбоджа',
  KI: 'Кирибати',
  KM: 'Коморские Острова',
  KP: 'КНДР',
  KR: 'Южная Корея',
  KW: 'Кувейт',
  KZ: 'Казахстан',
  LA: 'Лаос',
  LB: 'Ливан',
  LK: 'Шри-Ланка',
  LR: 'Либерия',
  LS: 'Лесото',
  LT: 'Литва',
  LU: 'Люксембург',
  LV: 'Латвия',
  LY: 'Ливия',
  MA: 'Марокко',
  MD: 'Молдова',
  ME: 'Черногория',
  MG: 'Мадагаскар',
  MK: 'Северная Македония',
  ML: 'Мали',
  MM: 'Мьянма',
  MN: 'Монголия',
  MR: 'Мавритания',
  MT: 'Мальта',
  MU: 'Маврикий',
  MV: 'Мальдивы',
  MW: 'Малави',
  MX: 'Мексика',
  MY: 'Малайзия',
  MZ: 'Мозамбик',
  NA: 'Намибия',
  NE: 'Нигер',
  NG: 'Нигерия',
  NI: 'Никарагуа',
  NL: 'Нидерланды',
  NO: 'Норвегия',
  NP: 'Непал',
  NZ: 'Новая Зеландия',
  OM: 'Оман',
  PA: 'Панама',
  PE: 'Перу',
  PG: 'Папуа — Новая Гвинея',
  PH: 'Филиппины',
  PK: 'Пакистан',
  PL: 'Польша',
  PT: 'Португалия',
  PW: 'Палау',
  PY: 'Парагвай',
  QA: 'Катар',
  RO: 'Румыния',
  RS: 'Сербия',
  RU: 'Россия',
  RW: 'Руанда',
  SA: 'Саудовская Аравия',
  SB: 'Соломоновы Острова',
  SC: 'Сейшелы',
  SD: 'Судан',
  SE: 'Швеция',
  SG: 'Сингапур',
  SI: 'Словения',
  SK: 'Словакия',
  SL: 'Сьерра-Леоне',
  SM: 'Сан-Марино',
  SN: 'Сенегал',
  SO: 'Сомали',
  SR: 'Суринам',
  SS: 'Южный Судан',
  ST: 'Сан-Томе и Принсипи',
  SV: 'Сальвадор',
  SY: 'Сирия',
  SZ: 'Эсватини',
  TD: 'Чад',
  TG: 'Того',
  TH: 'Таиланд',
  TJ: 'Таджикистан',
  TL: 'Тимор-Лесте',
  TM: 'Туркменистан',
  TN: 'Тунис',
  TO: 'Тонга',
  TR: 'Турция',
  TT: 'Тринидад и Тобаго',
  TV: 'Тувалу',
  TZ: 'Танзания',
  UA: 'Украина',
  UG: 'Уганда',
  US: 'США',
  UY: 'Уругвай',
  UZ: 'Узбекистан',
  VA: 'Ватикан',
  VC: 'Сент-Винсент и Гренадины',
  VE: 'Венесуэла',
  VN: 'Вьетнам',
  VU: 'Вануату',
  WS: 'Самоа',
  YE: 'Йемен',
  ZA: 'Южная Африка',
  ZM: 'Замбия',
  ZW: 'Зимбабве',
};

/**
 * Возвращает название страны по ISO-коду.
 * Если код не найден — возвращает сам код.
 */
export function getCountryName(code: string): string {
  return COUNTRY_NAMES[code.toUpperCase()] ?? code;
}

/**
 * Возвращает список стран из ISO-кодов с полными названиями,
 * отсортированный по русскому названию.
 */
export function sortedCountriesWithNames(codes: string[]): Array<{ code: string; name: string }> {
  return codes
    .map(code => ({ code, name: getCountryName(code) }))
    .sort((a, b) => a.name.localeCompare(b.name, 'ru'));
}
